import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageField, UploadFileV2 } from 'team-hero-ui';

import { UploadFileStyled, UploadImageStyled } from './UploadImage.styled';
import { useFileMimeType } from 'hooks/useFileMimeType.hook';

interface IUploadImageProps {
  value?: File;
  label?: string;
  onChange: (file: File | null) => void;
  helperText?: string;
}

export const UploadImage: FC<IUploadImageProps> = ({
  value,
  onChange,
  label,
  helperText,
}) => {
  const { t } = useTranslation('form');
  const { acceptImageFiles } = useFileMimeType();

  const handleRemove = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return (
    <UploadImageStyled>
      {!value && (
        <UploadFileStyled>
          <UploadFileV2
            accept={acceptImageFiles}
            onAdd={(file) => onChange(file)}
            styleType='grey'
            helperText={helperText}
          />
          <span>{label ? label : t('component.uploadPicture')}</span>
        </UploadFileStyled>
      )}
      {!!value && (
        <ImageField
          key={value.name}
          imgUrl=''
          file={value}
          onDelete={handleRemove}
        />
      )}
    </UploadImageStyled>
  );
};
